import styled, { css } from 'styled-components';

import { Flexer } from '@ontruck/orc';

const cardStyles = ({ theme }) => css`
  background: transparent;
  flex-direction: column;
  max-width: 350px;
  margin: 0.8rem;
  width: calc(50% - 1.6rem);
`;

const StyledCard = styled(Flexer.Parent)`
  ${cardStyles};
`;

export default StyledCard;
